import { t } from '@lingui/core/macro'
import moment from 'moment'
import { convertDateFieldToMomentJsFormat } from './convertDateUtil'

export const validateDateHelper = (dateString, field) => {
  if (!dateString) return

  const dateFormat = convertDateFieldToMomentJsFormat(field)
  const momentDate = moment(dateString, dateFormat)
  const formattedDate = momentDate.format(dateFormat)
  const isValidDate = momentDate.isValid()
  const isCorrectFormat = !dateFormat || formattedDate === dateString
  const errors = []

  if (!isValidDate) {
    errors.push(t`Value must be a date`)
  }

  if (!isCorrectFormat) {
    errors.push(t`Value should match format ${dateFormat}`)
  }

  const maxYear = 2099
  if (momentDate.year() > maxYear) {
    errors.push(t`Maximum year is ${maxYear}`)
  }

  return errors
}
